import Menu from '../Menu'

export const getRoutePermissions = pathname => {
	const cleanPath = pathname.split('/')[1]
	let permissions = []

	Menu.forEach(item => {
		if (item.path?.replace('/', '') === cleanPath) {
			permissions = item.permissions || []
		}

		if (item.submenu) {
			item.submenu.forEach(sub => {
				if (sub.path?.replace('/', '') === cleanPath) {
					permissions = sub.permissions?.length > 0 ? sub.permissions : item.permissions || []
				}
			})
		}
	})

	return permissions
}
